import { CRM } from "@/components/atomic-crm/root/CRM";

// CMG360 branding and CRM values live in root/defaultConfiguration.ts so they
// also apply after logout/login, when the stored configuration is cleared.
const App = () => <CRM disableTelemetry />;

export default App;
